(function fullImageViewerOpener(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (Object.hasOwnProperty.call(window, "ActiveXObject") && !window.ActiveXObject) {
    return;
  }

  const previousFullImageViewerOpener = global.NewHomeSource.FullImageViewerOpener;
  const template = document.querySelector('[data-component="full-image-viewer-template"]');

  /**
   * @private
   * generateHtml: creates the Full Image Viewer HTML and appends it to the DOM.
   *
   * @param {function} callback function to execute after the HTML has been appended.
   */
  function generateHtml(callback) {
    global.NewHomeSource.ModalBackground.createBackground('rgba(0,0,0,.82)');
    document.body.appendChild(template.content.cloneNode(true));

    const container = global.document.querySelector('[data-component="full-image-viewer"]');

    if (container) {
      container.focus({ preventScroll: true });
    }

    if (typeof callback === 'function') {
      callback(callback.prototype);
    }
  }

  /**
   * @private
   * openFullImageViewer: creates the HTML needed to display the Full Image Viewer.
   *
   * @param {function} callback to execute after the HTML has been added to the DOM.
   * @param {Event} event with the information associated to the opener event.
   */
  function openFullImageViewer(callback, event) {
    event.preventDefault();
    if (!template) {
      return;
    }

    requestAnimationFrame(generateHtml.bind(this, callback));
    event.target.setAttribute('data-full-image-viewer-trigger', 'true');
  }

  const eventsConfiguration = {
    openEvent: {
      callbacks: [],
      events: ['click', 'touchend'],
    },
  };

  /**
  * @private
  * registerLogInformation: register in the global object the information for loging events.
  *
  * @param {logger} object contains the logic in charge of logging events.
  * @param {logInfo} object with the listing information necessary for log events.
  */
  function registerLogInformation(logger, logInfo) {
    global.performanceLogger = logger;
    global.logInfo = logInfo;
  }

  /**
   * @constructs NewHomeSource.FullImageViewerOpener
   *
   * @param {object} options configurations to indicate how to open the Full Image Viewer.
   */
  function FullImageViewerOpener(options) {
    this.FullImageViewerOpener.options = options || {};
    eventsConfiguration.openEvent.elements = this.FullImageViewerOpener.options.selector;
    eventsConfiguration.openEvent.callbacks.push(
      openFullImageViewer.bind(null, options.favorites.setUpFullImageViewerSaveOption)
    );
    eventsConfiguration.openEvent.callbacks.push(registerLogInformation.bind(null,
      options.performanceEvents, options.logInfo)
    );
    global.NewHomeSource.Event(eventsConfiguration);
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewerOpener to the previous script.
   */
  FullImageViewerOpener.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewerOpener = previousFullImageViewerOpener;
    return FullImageViewerOpener;
  };

  global.NewHomeSource.FullImageViewerOpener = FullImageViewerOpener;
}(window));
